import { useFormik } from 'formik'
import { FC } from 'react'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import InputSelect from '../../../global/InputSelect/InputSelect'
import InputText from '../../../global/InputText/InputText'
import Modal from '../../../global/Modal/Modal'
import SimpleButton from '../../../global/SimpleButton/SimpleButton'
import { addEditDataAPI } from '../../../services/CRUDServices'
import { addEditUrls } from '../../../services/api.enums'
import { useEmployeeAndZoneOptions } from './useGetOption'

interface EditZoneFromProps {
  modalInfo: any
  isOpen: boolean
  setIsOpen: any
  // setModalInfo: (modalInfo: any) => void
  onUpdate: () => void
}
const EditZoneFrom: FC<EditZoneFromProps> = ({
  modalInfo,
  isOpen,
  // setModalInfo,
  onUpdate,
  setIsOpen,
}) => {
  const { optionZone, perssonelOption } = useEmployeeAndZoneOptions({
    isOpen,
    onUpdate,
  })

  const valicationCreate = Yup.object().shape({
    code: Yup.string().required(),
    name: Yup.string().required(),
    countrytype: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    employee: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })


  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: valicationCreate,
    initialValues: {
      code: modalInfo?.code,
      name: modalInfo?.name,
      countrytype: modalInfo?.countryType,
      employee: {
        id: modalInfo?.selectResponsiblePersonel.id,
        text: perssonelOption.find((personel)=>personel.id === modalInfo?.selectResponsiblePersonel.id)?.text,
      },
    },
    onSubmit: async (values, { resetForm }) => {
      const data = {
        id: modalInfo?.id,
        code: values.code,
        name: values.name,
        countryType: values.countrytype,

        selectResponsiblePersonel: values.employee,
        selectHub: modalInfo.selectHub,
      }
      try {
        await addEditDataAPI(addEditUrls.countryDevision, 'put', data)
        toast.success('ویرایش زیر منطقه با موفقیت انجام شد')
        // setModalInfo({
        //   isOpen: false,
        //   formData: undefined,
        // })
        onUpdate()
        setIsOpen(false)
      } catch (error) {}
    },
  })

  return (
    <Modal
      visible={isOpen}
      setVisible={() => setIsOpen}
      title={'ویرایش  اطلاعات زیر منطقه'}
    >
      <form onSubmit={formik.handleSubmit} className='p-6 '>
        <div className='grid grid-cols-2 gap-6 my-6'>
          <div className='inputRow'>
            <InputText
              readOnly
              wrapperClassName='w-full'
              label='کد '
              name='code'
              handleChange={formik.handleChange}
              values={formik.values.code}
              important
              type={'text'}
              error={formik.errors.code}
            />
          </div>
          <div className='inputRow'>
            <InputText
              wrapperClassName='w-full'
              label='عنوان'
              name='name'
              handleChange={formik.handleChange}
              values={formik.values.name}
              important
              type={'text'}
              error={formik.errors.name}
            />
          </div>
          <div>
            <InputSelect
              wrapperClassName='w-full '
              name='countrytype'
              label='نوع منطقه'
              values={formik.values.countrytype}
              handleChange={(name: string, value: object) => {
                formik.setFieldValue(name, value)
              }}
              options={optionZone}
            />
          </div>
          <div>
            <InputSelect
              wrapperClassName='w-full '
              name='employee'
              label='پرسنل هاب'
              values={formik.values.employee}
              handleChange={(name: string, value: object) => {
                formik.setFieldValue(name, value)
              }}
              options={perssonelOption}
            />
          </div>
        </div>
        <div className='grid grid-cols-4 gap-6 '>
          <div className='col-span-2' />
          <div className='col-span-2 flex gap-4 w-full justify-end'>
            <SimpleButton
              type='submit'
              text={' ویرایش'}
              className='full-tomato-btn px-[90px] '
            />
            <SimpleButton
              type='button'
              text='لغو'
              className='full-lightTomato-btn px-[90px]'
              handelClick={() => {
                setIsOpen(false)
                formik.resetForm()
              }}
            />
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default EditZoneFrom
